import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(() => {
  return {
    otherTextField: {
      width: '100%'
    }
  };
});

function normalizeInput(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return value;
}

export const OtherTextField = props => {
  const { label, variant, onChange, error, value, required, disabled, InputProps, maxCharactersAllowed } = props;
  const { otherTextField } = useStyles();

  const { t: translate } = useTranslation();

  // Prevent null or undefined input
  const normalizedInput = normalizeInput(value);

  // Init state
  const [input, setInput] = useState(normalizedInput);

  // Init character count
  const [characterCount, setCharacterCount] = useState(normalizedInput.length);

  // Init error
  const [errorMsg, setError] = useState(error);

  // Show new input when value prop is updated
  useEffect(() => {
    setInput(normalizedInput);
    setCharacterCount(normalizedInput.length);
  }, [normalizedInput]);

  // Update error if error prop changes
  useEffect(() => {
    setError(error);
  }, [error]);

  const onInput = useCallback(
    event => {
      const enforcedValue = event.target.value;
      onChange(event);
      setInput(enforcedValue);
      setCharacterCount(enforcedValue.length);
    },
    [onChange]
  );

  let updatedInputProps = InputProps;
  if (maxCharactersAllowed) {
    const IP = InputProps || {};
    const ip = IP.inputProps || {};
    updatedInputProps = {
      ...IP,
      inputProps: {
        ...ip,
        maxLength: maxCharactersAllowed
      }
    };
  }

  return (
    <>
      <TextField
        value={input}
        onChange={onInput}
        label={label || translate('common.pleaseSpecify')}
        multiline
        InputProps={updatedInputProps}
        disabled={disabled}
        className={otherTextField}
        rows={3}
        variant={variant || 'filled'}
        error={!!error}
        required={required}
      />
      <div className="threepp-input-field-helper-text-section">
        {errorMsg && (
          <FormHelperText className="threepp-input-error" error>
            {errorMsg}
          </FormHelperText>
        )}
        {maxCharactersAllowed && (
          <FormHelperText className="threepp-input-char-count">{`${characterCount} / ${maxCharactersAllowed}`}</FormHelperText>
        )}
      </div>
    </>
  );
};
